package kpt.core.database

import androidx.room3.migration.AutoMigrationSpec
import androidx.room3.migration.Migration
import androidx.sqlite.SQLiteConnection
import androidx.sqlite.execSQL
import kotlin.Suppress
import kpt.core.database.migrations.MigrationSpec8to10

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "OPT_IN_USAGE_ERROR", "OPT_IN_USAGE", "MemberExtensionConflict", "CAN_BE_VAL"])
internal class AppDatabase_AutoMigration_8_10_Impl : Migration {
  private val callback: AutoMigrationSpec = MigrationSpec8to10()

  public constructor() : super(8, 10)

  public override suspend fun migrate(connection: SQLiteConnection) {
    connection.execSQL("DROP TABLE `samples`")
    connection.execSQL("CREATE TABLE IF NOT EXISTS `alerts` (`id` TEXT NOT NULL, `symbol` TEXT NOT NULL, `targetPrice` REAL NOT NULL, `conditionAbove` INTEGER NOT NULL, `createdAt` INTEGER NOT NULL, PRIMARY KEY(`id`))")
    connection.execSQL("CREATE TABLE IF NOT EXISTS `interest_rate_series` (`seriesId` TEXT NOT NULL, `date` TEXT NOT NULL, `value` REAL NOT NULL, `updatedAt` INTEGER NOT NULL, PRIMARY KEY(`seriesId`, `date`))")
    callback.onPostMigrate(connection)
  }
}
